import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
export var seoMetadataActions;
(function (seoMetadataActions) {
    seoMetadataActions["GET_SEO_DATA_REQUEST"] = "GET_SEO_DATA_REQUEST";
    seoMetadataActions["GET_SEO_DATA_SUCCESS"] = "GET_SEO_DATA_SUCCESS";
    seoMetadataActions["GET_SEO_DATA_ERROR"] = "GET_SEO_DATA_ERROR";
    seoMetadataActions["RESET_SEO_METADATA"] = "RESET_SEO_METADATA";
    seoMetadataActions["RENDER_SEO_PRICELIST"] = "RENDER_SEO_PRICELIST";
})(seoMetadataActions || (seoMetadataActions = {}));
export function renderSeoPriceList(data) {
    return {
        type: seoMetadataActions.RENDER_SEO_PRICELIST,
        data
    };
}
export function resetSEOMetadataAction() {
    return {
        type: seoMetadataActions.RESET_SEO_METADATA
    };
}
export function fetchSEOMetadataAction(pageUrl, requestHeaders = {}, serverSide = false) {
    if (serverSide) {
        requestHeaders['X-Flipkart-Client'] = 'zion-server';
    }
    return (dispatch) => {
        dispatch({
            type: seoMetadataActions.GET_SEO_DATA_REQUEST
        });
        // This change is temporary. Most SEO metadata calls for grocery browse are timing out. This will stay till the time a fix is found for it.
        const params = new URLSearchParams(pageUrl);
        const isGroceryUrl = params.has('marketplace') && params.get('marketplace').toUpperCase() === 'GROCERY';
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/3/seo/desktop/metadata?url=${encodeURIComponent(pageUrl)}`,
            action: seoMetadataActions.GET_SEO_DATA_REQUEST,
            headers: Object.assign({}, headers, requestHeaders),
            fk_api_timeout: __SERVER__ && !isGroceryUrl ? 500 : baseAjaxConfig.fk_api_timeout
        })).then(json => dispatch({
            type: seoMetadataActions.GET_SEO_DATA_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: seoMetadataActions.GET_SEO_DATA_ERROR,
                error: err
            });
        });
    };
}
